export default "__VITE_ASSET__DZqgpAA6__"